import React from "react";
import { Select, MenuItem } from "@material-ui/core";

import SpotlioIcon from "../../Icon";

import request from "../../../utils/request"

import "./index.scss";

export default class CitySearcher extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            loadingDestinations: true,
            destinations: [],
        }
    }

    componentDidMount() {
        this.getDestinations();
    }
    
    handleClick = (e) => {
        if (this.node){
          if ( !this.node.contains(e.target) ){
            this.setState({ displayDestinations: false })
          }
        }
    }

    getDestinations = () => {
        request({
            url: "https://connect-dev.spotlio.com/destination/all?module=koedia",
            method: "GET"
        })
        .then((res) => {
            const destinations = []
            if (res.status === 200 && res.data.length > 0) {
                res.data.forEach((destination) => {
                    destinations.push({ name: destination.name, id: destination.id })
                })
            }
            this.setState({ loadingDestinations: false, destinations });
        })
        
    }

    render(){
        const { state, props } = this;
        const { destinations, loadingDestinations } = state;
        const { destination, changeDestination } = props;
        
        if (loadingDestinations) return null;

        return(
            <Select 
                IconComponent={() => <SpotlioIcon icon="feather-chevron-down" />} 
                onChange={(e) => { changeDestination(destinations.find(destination => destination.id === e.target.value)) }} 
                value={destination.id} 
                className="destinations"
            >
                {destinations.map((destination) => {
                    return (
                        <MenuItem value={destination.id}>{destination.name}</MenuItem>
                    )
                })}
            </Select>
        )
    }
}